import type { ChallengeDetail } from "../types/challengeAdmin";
import { normalizePairId } from "./challengePairs";

const key = (value: unknown) => String(value || "").trim().toLowerCase();
const pairCpfKey = (first: unknown, second: unknown) =>
  [String(first || "").replace(/\D/g, ""), String(second || "").replace(/\D/g, "")].sort().join("-");

export function selectCategoryRounds(
  rounds: ChallengeDetail["roundsDetailed"], categoryKey: string, categoryCount: number,
) {
  const selected = key(categoryKey);
  return rounds.map(round => round.filter(match =>
    key(match.categoryKey) === selected || (!key(match.categoryKey) && categoryCount === 1),
  )).filter(round => round.length > 0)
    .map((round, index) => round.map(match => ({ ...match, round: index + 1 })));
}

export function selectCategoryPairs(
  challenge: Pick<ChallengeDetail, "pairs" | "registrations" | "registrationCategories">,
  rounds: ChallengeDetail["roundsDetailed"], categoryKey: string,
) {
  const ids = new Set(rounds.flatMap(round => round.flatMap(match =>
    [normalizePairId(match.dupla1Id), normalizePairId(match.dupla2Id)])).filter(Boolean));
  if (ids.size) return challenge.pairs.filter(pair => ids.has(normalizePairId(pair.id)));
  if (challenge.registrations?.length) {
    const cpfs = new Set(challenge.registrations
      .filter(row => key(row.registrationCategoryKey) === key(categoryKey) &&
        row.registrationStatus !== "canceled" && !["canceled", "refunded"].includes(row.paymentStatus))
      .map(row => pairCpfKey(row.player1Cpf, row.player2Cpf)));
    return challenge.pairs.filter(pair => cpfs.has(pairCpfKey(pair.cpf1, pair.cpf2)));
  }
  return (challenge.registrationCategories?.length || 0) <= 1 ? challenge.pairs : [];
}
